import { createContext, useContext, useState } from "react";
import { filterByName } from "./util";

const FilterContext = createContext();
export function Filter(props) {
    const [filter, setFilter] = useState('')
    return <FilterContext.Provider
        value={{
            filter,
            setFilter
        }}
        {...props}
    />
}

export function useFilter() {
    const { filter, setFilter } = useContext(FilterContext)
    const f_byNAme = filterByName(filter);

    return {
        active: filter.trim().length > 0,
        filter,
        setFilter,

        filterByName: f_byNAme,
        clear: () => setFilter('')
    }
}